<style>
  div {
    border-radius: 5px;
  }
  form {
    width: 80%;
    margin: auto;
    text-align: center;
  }
  .form-group {
    margin-bottom: 1rem;
    text-align: left;
}
  input:placeholder-shown {
    background-color:#EBEBEB!important;
    outline: 1px solid #4F4D4A;
    border-radius: 0;
  }
  input{
    background-color:#EBEBEB!important;
    outline: 1px solid #4F4D4A;
    border-radius: 0;
  }
  select{
    min-width: 170px;
    background-color:#EBEBEB!important;
    outline: 1px solid #4F4D4A;
    border-radius: 0;
  }
  select option {
  background-color:white!important;
}
  </style>
<!--  ----------------------------------------------------------------------  -->
<!--  NOTE: Please add the following <META> element to your page <HEAD>.      -->
<!--  If necessary, please modify the charset parameter to specify the        -->
<!--  character set of your HTML page.                                        -->
<!--  ----------------------------------------------------------------------  -->
<div class="mercedes-me-login__column_left">
  <h2 class="mercedes-me-login__column_left-headline">Request More Information</h2>
</div>

<META HTTP-EQUIV="Content-type" CONTENT="text/html; charset=UTF-8">

  <!--  ----------------------------------------------------------------------  -->
  <!--  NOTE: Please add the following <FORM> element to your page.             -->
  <!--  ---------------------------------------------------------------------------  -->
  <div *ngIf="this.env==='local'"> 

    <!-- <form [formGroup]="loginForm" (ngSubmit)="submitForm($event)" *ngIf="openLoginModal && userExist"> -->
    <form ngNoForm action="https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST">
    
    <input type=hidden name="oid" value="00D0q0000009ke9">
    <input type=hidden name="retURL" value="{{this.usUrl}}/home">
    
    <div class="shortrow">
      <div class="form-group">
        <label class ="inputlabel" for="first_name">First Name*</label>
        <input type="text" class="form-control" required validateonblur value=""
        placeholder= " " id="first_name" maxlength="40" name="first_name" >
      </div>
  
      <div class="form-group">
        <label class ="inputlabel" for="last_name">Last Name*</label>
        <input type="text" class="form-control"  required validateonblur value=""
        placeholder= " " id="last_name" maxlength="80" name="last_name">
      </div>
  </div>
  <div class="shortrow">
    <div class="form-group">
      <label class ="inputlabel" for="company">Company*</label>
      <input type="text" class="form-control"  required validateonblur value=""
      placeholder= " " id="company" maxlength="255" name="company">
    </div>
    <div class="form-group">
      <label class ="inputlabel" for="phone">Contact Phone: * </label>
    <input class="form-control" type="number" formControlName="phone" [(ngModel)]="phone" required validateonblur value=""  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" (input)="inputValidator($event)" maxlength="10" placeholder= " " id="phone" name="phone" >
    </div>
  </div>
  <div class="shortrow">
    <div class="form-group">
      <label class ="inputlabel" for="email">Contact Email: * </label>
      <input class="form-control" type="email"   name="email"  ngModel  #emailWithPattern="ngModel"   pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$"  maxlength="80" required  >
    </div> 
    <div class="form-group">
      <label class ="inputlabel" for="00N0q000005yxRz">Estimated Number of Units: * </label>
      <input class="form-control"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" type = "number"  maxlength="18" required validateonblur value=""
      placeholder= " " id="00N0q000005yxRz" name="00N0q000005yxRz">
    </div>
  </div>
  
  <div class="shortrow">
      <div class="form-group">
        <label class ="inputlabel" for="00NDJ000006ZAZ0">State: * </label>
        <select class="form-control" (ngModelChange)="getCounties()" required [formControl]="state" id="00NDJ000006ZAZ0" name="00NDJ000006ZAZ0" placeholder= "State" 
        required value="">
          <option *ngFor="let state of states" [value]="state">
            {{ state }}
          </option>
        </select>
    </div>
      <div class="form-group">
        <label class ="inputlabel" for="00N0q000006CSsU">County: * </label>
          <select class="form-control" required [formControl]="county" id="00N0q000006CSsU" name="00N0q000006CSsU" placeholder= "County" required value="">
            <option *ngFor="let county of counties" [value]="county">
              {{ county }}
            </option>
          </select>
    </div>
  </div>

  <div class="shortrow1">
    <div class="form-group">
      <label class ="inputlabel" for="00N0q000006BoyQ">DOT Number: * </label>
      <input type="text" class="form-control" required validateonblur value="" 
       placeholder= " " id="00N0q000006BoyQ" maxlength="30" name="00N0q000006BoyQ">
    </div>  
    <div class="form-group">
      <label class ="inputlabel" for="00N0q000006Bm9A">Insurance Renewal Date: </label>
      <mat-form-field appearance="outline" style="padding: 0%;">
        <input  class="form-control" id="00N0q000006Bm9A" name="00N0q000006Bm9A" readonly matInput [matDatepicker]="picker" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    </div>
  
  <!--Validation Errors-->
  <div class="shortrow">
      <div *ngIf="showPhoneErrors">
        <div *ngIf="!this.phoneValid">  
          <li style="color:black;"  *ngIf="!this.hasNumeric">{{ 'LoginModal.PhoneNumeric' | translate }}</li>
          <li style="color:black;"  *ngIf="!this.phoneLength">{{ 'LoginModal.PhoneLength' | translate }}</li>
        </div>
      </div>  
    </div>
    <div class="shortrow">
      <div *ngIf="emailWithPattern.pristine || emailWithPattern.invalid ">
        <li  style="color:black;" *ngIf="emailWithPattern.errors?.pattern">This is not a valid Email.</li>
      </div>  
    </div>
    
      <!-- <label for="recordType">Lead Record Type</label> -->
      <select  id="recordType" name="recordType" hidden>
        <option value="">--None--</option>
        <option value="0121I000000Jso2">DTNA Orderboard Leads</option>
        <option value="0121I000000JtAG">DTNA Program Lead</option>
        <option value="0120q000000mBFL" selected="selected">Dynamic Insurance Lead</option>
        <option value="0121I000000JtAL">FMV</option>
        <option value="0121I000000Jso7">Other</option>
        </select>
  
      <!-- <label for="lead_source">Lead Source</label> -->
      <select  id="lead_source" name="lead_source" hidden>
        <option value="">--None--</option>
        <option value="Dealer">Dealer</option>
        <option value="HDVI">HDVI</option>
        <option value="DTNA_Orderboard">DTNA_Orderboard</option>
        <option value="Other">Other</option>
        <option value="Dynamic Lease">Dynamic Lease</option>
        <option value="DTNA Program">DTNA Program</option>
        <option value="DTNA/DTR FMV">DTNA/DTR FMV</option>
        <option value="Dynamic Insurance Lead">Dynamic Insurance Lead</option>
        <option value="Website - Dynamic Lease">Website - Dynamic Lease</option>
        <option value="Website - Dynamic Insurance"  selected="selected">Website - Dynamic Insurance</option>
        <option value="Email">Email</option>
        </select>
  
  <div class="form-check">
    <label class="checkboxlabel" for="checkbox">
      <input type="checkbox" class="form-check-input" id="checkbox" name="checkbox" required>* I agree that Daimler Truck Financial Services and its partners may contact me via the email address or phone number provided in this form with promotional messages, offers, updates and other marketing messages. I understand and agree that Daimler Truck Financial Services and its partners may use my information in accordance with its <a href="{{this.usUrl}}/home/useAndPrivacy">&#8250;Privacy Policy</a>.
    </label>
  </div><br>
  
    <!--Error Display to Modal View-->
    <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
      <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
    </div>
    <div class="captcha" *ngIf="this.captchaToggle">
      <div id="capcha_element" class="g-recaptcha" data-theme="light"
          style="transform:scale(0.85);-webkit-transform:scale(0.85);transform-origin:0 0;-webkit-transform-origin:0 0; display:inline-block; text-align: center;padding-left: 10%;" data-callback="getResponceCapcha"
          data-expired-callback="recaptchaResponseExpired" data-error-callback="recaptchaError">
        </div>
    </div>
  
    <button type="submit" name="submit" [disabled]="(emailWithPattern.errors?.pattern || !this.phoneValid)" class="mbfs-button">Submit</button><br><br>
    </form>
    </div>
 
  <div *ngIf="this.env==='stage'"> 

    <form ngNoForm action="https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST">
    
      <input type=hidden name="oid" value="00D0q0000009ke9">
      <input type=hidden name="retURL" value="{{this.usUrl}}/home">
      
      <div class="shortrow">
        <div class="form-group">
          <label class ="inputlabel" for="first_name">First Name*</label>
          <input type="text" class="form-control" required validateonblur value=""
          placeholder= " " id="first_name" maxlength="40" name="first_name" >
        </div>
    
        <div class="form-group">
          <label class ="inputlabel" for="last_name">Last Name*</label>
          <input type="text" class="form-control"  required validateonblur value=""
          placeholder= " " id="last_name" maxlength="80" name="last_name">
        </div>
    </div>
    <div class="shortrow">
      <div class="form-group">
        <label class ="inputlabel" for="company">Company*</label>
        <input type="text" class="form-control"  required validateonblur value=""
        placeholder= " " id="company" maxlength="255" name="company">
      </div>
      <div class="form-group">
        <label class ="inputlabel" for="phone">Contact Phone: * </label>
      <input class="form-control" type="number" formControlName="phone" [(ngModel)]="phone" required validateonblur value=""  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" (input)="inputValidator($event)" maxlength="10" placeholder= " " id="phone" name="phone" >
      </div>
    </div>
    <div class="shortrow">
      <div class="form-group">
        <label class ="inputlabel" for="email">Contact Email: * </label>
        <input class="form-control" type="email"   name="email"  ngModel  #emailWithPattern="ngModel"   pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$"  maxlength="80" required  >
      </div> 
      <div class="form-group">
        <label class ="inputlabel" for="00N0q000005yxRz">Estimated Number of Units: * </label>
        <input class="form-control"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" type = "number"  maxlength="18" required validateonblur value=""
        placeholder= " " id="00N0q000005yxRz" name="00N0q000005yxRz">
      </div>
    </div>
    
    <div class="shortrow">
        <div class="form-group">
          <label class ="inputlabel" for="00NDJ000006ZAZ0">State: * </label>
          <select class="form-control" (ngModelChange)="getCounties()" required [formControl]="state" id="00NDJ000006ZAZ0" name="00NDJ000006ZAZ0" placeholder= "State" 
          required value="">
            <option *ngFor="let state of states" [value]="state">
              {{ state }}
            </option>
          </select>
      </div>
        <div class="form-group">
          <label class ="inputlabel" for="00N0q000006CSsU">County: * </label>
            <select class="form-control" required [formControl]="county" id="00N0q000006CSsU" name="00N0q000006CSsU" placeholder= "County" required value="">
              <option *ngFor="let county of counties" [value]="county">
                {{ county }}
              </option>
            </select>
      </div>
    </div>

    <div class="shortrow1">
      <div class="form-group">
        <label class ="inputlabel" for="00N0q000006BoyQ">DOT Number: * </label>
        <input type="text" class="form-control" required validateonblur value="" 
         placeholder= " " id="00N0q000006BoyQ" maxlength="30" name="00N0q000006BoyQ">
      </div>  
      <div class="form-group">
        <label class ="inputlabel" for="00N0q000006Bm9A">Insurance Renewal Date: </label>
        <mat-form-field appearance="outline" style="padding: 0%;">
          <input  class="form-control" id="00N0q000006Bm9A" name="00N0q000006Bm9A" readonly matInput [matDatepicker]="picker" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      </div>
    
    <!--Validation Errors-->
    <div class="shortrow">
        <div *ngIf="showPhoneErrors">
          <div *ngIf="!this.phoneValid">  
            <li style="color:black;"  *ngIf="!this.hasNumeric">{{ 'LoginModal.PhoneNumeric' | translate }}</li>
            <li style="color:black;"  *ngIf="!this.phoneLength">{{ 'LoginModal.PhoneLength' | translate }}</li>
          </div>
        </div>  
      </div>
      <div class="shortrow">
        <div *ngIf="emailWithPattern.pristine || emailWithPattern.invalid ">
          <li  style="color:black;" *ngIf="emailWithPattern.errors?.pattern">This is not a valid Email.</li>
        </div>  
      </div>
      
        <!-- <label for="recordType">Lead Record Type</label> -->
        <select  id="recordType" name="recordType" hidden>
          <option value="">--None--</option>
          <option value="0121I000000Jso2">DTNA Orderboard Leads</option>
          <option value="0121I000000JtAG">DTNA Program Lead</option>
          <option value="0120q000000mBFL" selected="selected">Dynamic Insurance Lead</option>
          <option value="0121I000000JtAL">FMV</option>
          <option value="0121I000000Jso7">Other</option>
          </select>
    
        <!-- <label for="lead_source">Lead Source</label> -->
        <select  id="lead_source" name="lead_source" hidden>
          <option value="">--None--</option>
          <option value="Dealer">Dealer</option>
          <option value="HDVI">HDVI</option>
          <option value="DTNA_Orderboard">DTNA_Orderboard</option>
          <option value="Other">Other</option>
          <option value="Dynamic Lease">Dynamic Lease</option>
          <option value="DTNA Program">DTNA Program</option>
          <option value="DTNA/DTR FMV">DTNA/DTR FMV</option>
          <option value="Dynamic Insurance Lead">Dynamic Insurance Lead</option>
          <option value="Website - Dynamic Lease">Website - Dynamic Lease</option>
          <option value="Website - Dynamic Insurance"  selected="selected">Website - Dynamic Insurance</option>
          <option value="Email">Email</option>
          </select>
    
    <div class="form-check">
      <label class="checkboxlabel" for="checkbox">
        <input type="checkbox" class="form-check-input" id="checkbox" name="checkbox" required>* I agree that Daimler Truck Financial Services and its partners may contact me via the email address or phone number provided in this form with promotional messages, offers, updates and other marketing messages. I understand and agree that Daimler Truck Financial Services and its partners may use my information in accordance with its <a href="{{this.usUrl}}/home/useAndPrivacy">&#8250;Privacy Policy</a>.
      </label>
    </div><br>
    
      <!--Error Display to Modal View-->
      <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
        <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
      </div>
      <div class="captcha" *ngIf="this.captchaToggle">
        <div id="capcha_element" class="g-recaptcha" data-theme="light"
            style="transform:scale(0.85);-webkit-transform:scale(0.85);transform-origin:0 0;-webkit-transform-origin:0 0; display:inline-block; text-align: center;padding-left: 10%;" data-callback="getResponceCapcha"
            data-expired-callback="recaptchaResponseExpired" data-error-callback="recaptchaError">
          </div>
      </div>
    
      <button type="submit" name="submit" [disabled]="(emailWithPattern.errors?.pattern || !this.phoneValid)" class="mbfs-button">Submit</button><br><br>
      </form>

  </div>

  <div *ngIf="this.env==='prod'"> 

    <form ngNoForm action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST">
      <input type=hidden name="oid" value="00D1I000001XfK4">
      <input type=hidden name="retURL" value="{{this.usUrl}}/home">
      
      <div class="shortrow">
        <div class="form-group">
          <label class ="inputlabel" for="first_name">First Name*</label>
          <input type="text" class="form-control" required validateonblur value=""
          placeholder= " " id="first_name" maxlength="40" name="first_name" >
        </div>
    
        <div class="form-group">
          <label class ="inputlabel" for="last_name">Last Name*</label>
          <input type="text" class="form-control"  required validateonblur value=""
          placeholder= " " id="last_name" maxlength="80" name="last_name">
        </div>
    </div>
    <div class="shortrow">
      <div class="form-group">
        <label class ="inputlabel" for="company">Company*</label>
        <input type="text" class="form-control"  required validateonblur value=""
        placeholder= " " id="company" maxlength="255" name="company">
      </div>
      <div class="form-group">
        <label class ="inputlabel" for="phone">Contact Phone: * </label>
      <input class="form-control" type="number" formControlName="phone" [(ngModel)]="phone" required validateonblur value=""  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" (input)="inputValidator($event)" maxlength="10" placeholder= " " id="phone" name="phone" >
      </div>
    </div>
    <div class="shortrow">
      <div class="form-group">
        <label class ="inputlabel" for="email">Contact Email: * </label>
        <input class="form-control" type="email"   name="email"  ngModel  #emailWithPattern="ngModel"   pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$"  maxlength="80" required  >
      </div> 
      <div class="form-group">
        <label class ="inputlabel" for="00N8W00000PY91u">Estimated Number of Units: * </label>
        <input class="form-control"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" type = "number"  maxlength="18" required validateonblur value=""
        placeholder= " " id="00N8W00000PY91u" name="00N8W00000PY91u">
      </div>
    </div>
    
    <div class="shortrow">
        <div class="form-group">
          <label class ="inputlabel" for="00N8W00000PYJyR">State: * </label>
          <select class="form-control" (ngModelChange)="getCounties()" required [formControl]="state" id="00N8W00000PYJyR" name="00N8W00000PYJyR" placeholder= "State" 
          required value="">
            <option *ngFor="let state of states" [value]="state">
              {{ state }}
            </option>
          </select>
      </div>
        <div class="form-group">
          <label class ="inputlabel" for="00N8W00000PYJyH">County: * </label>
            <select class="form-control" required [formControl]="county" id="00N8W00000PYJyH" name="00N8W00000PYJyH" placeholder= "County" required value="">
              <option *ngFor="let county of counties" [value]="county">
                {{ county }}
              </option>
            </select>
      </div>
    </div>

    <div class="shortrow1">
      <div class="form-group">
        <label class ="inputlabel" for="00N8W00000PY91k">DOT Number: * </label>
        <input type="text" class="form-control" required validateonblur value="" 
         placeholder= " " id="00N8W00000PY91k" maxlength="30" name="00N8W00000PY91k">
      </div>  
      <div class="form-group">
        <label class ="inputlabel" for="00N8W00000PY91o">Insurance Renewal Date: </label>
        <mat-form-field appearance="outline" style="padding: 0%;">
          <input  class="form-control" id="00N8W00000PY91o" name="00N8W00000PY91o" readonly matInput [matDatepicker]="picker" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      </div>
    
    <!--Validation Errors-->
    <div class="shortrow">
        <div *ngIf="showPhoneErrors">
          <div *ngIf="!this.phoneValid">  
            <li style="color:black;"  *ngIf="!this.hasNumeric">{{ 'LoginModal.PhoneNumeric' | translate }}</li>
            <li style="color:black;"  *ngIf="!this.phoneLength">{{ 'LoginModal.PhoneLength' | translate }}</li>
          </div>
        </div>  
      </div>
      <div class="shortrow">
        <div *ngIf="emailWithPattern.pristine || emailWithPattern.invalid ">
          <li  style="color:black;" *ngIf="emailWithPattern.errors?.pattern">This is not a valid Email.</li>
        </div>  
      </div>
      
        <!-- <label for="recordType">Lead Record Type</label> -->
        <select  id="recordType" name="recordType" hidden>
          <option value="">--None--</option>
          <option value="0121I000000Jso2">DTNA Orderboard Leads</option>
          <option value="0121I000000JtAG">DTNA Program Lead</option>
          <option value="0120q000000mBFL" selected="selected">Dynamic Insurance Lead</option>
          <option value="0121I000000JtAL">FMV</option>
          <option value="0121I000000Jso7">Other</option>
          </select>
    
        <!-- <label for="lead_source">Lead Source</label> -->
        <select  id="lead_source" name="lead_source" hidden>
          <option value="">--None--</option>
          <option value="Dealer">Dealer</option>
          <option value="HDVI">HDVI</option>
          <option value="DTNA_Orderboard">DTNA_Orderboard</option>
          <option value="Other">Other</option>
          <option value="Dynamic Lease">Dynamic Lease</option>
          <option value="DTNA Program">DTNA Program</option>
          <option value="DTNA/DTR FMV">DTNA/DTR FMV</option>
          <option value="Dynamic Insurance Lead">Dynamic Insurance Lead</option>
          <option value="Website - Dynamic Lease">Website - Dynamic Lease</option>
          <option value="Website - Dynamic Insurance"  selected="selected">Website - Dynamic Insurance</option>
          <option value="Email">Email</option>
          </select>
    
    <div class="form-check">
      <label class="checkboxlabel" for="checkbox">
        <input type="checkbox" class="form-check-input" id="checkbox" name="checkbox" required>* I agree that Daimler Truck Financial Services and its partners may contact me via the email address or phone number provided in this form with promotional messages, offers, updates and other marketing messages. I understand and agree that Daimler Truck Financial Services and its partners may use my information in accordance with its <a href="{{this.usUrl}}/home/useAndPrivacy">&#8250;Privacy Policy</a>.
      </label>
    </div><br>
    
      <!--Error Display to Modal View-->
      <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
        <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
      </div>
      <div class="captcha" *ngIf="this.captchaToggle">
        <div id="capcha_element" class="g-recaptcha" data-theme="light"
            style="transform:scale(0.85);-webkit-transform:scale(0.85);transform-origin:0 0;-webkit-transform-origin:0 0; display:inline-block; text-align: center;padding-left: 10%;" data-callback="getResponceCapcha"
            data-expired-callback="recaptchaResponseExpired" data-error-callback="recaptchaError">
          </div>
      </div>
    
      <button type="submit" name="submit" [disabled]="(emailWithPattern.errors?.pattern || !this.phoneValid)" class="mbfs-button">Submit</button><br><br>
      </form>

  </div>


    <div class="mercedes-me-login__column_left">
      <p class="mercedes-me-login__column_left-paragraph_red_small">Thank you for your interest in Dynamic Lease. You will be contacted by a representative shortly.</p> 
   </div>
  